import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  HStack,
  Avatar,
  Text,
  Link,
} from "@chakra-ui/react";
import { SharedOwnedBusinessEntity } from "../../../shared/lib/types";
import TalkMessages from "./TalkMessages";
import { TalkRooms } from "../lib/types";
import OpenInNewIcon from "../../../shared/components/icons/OpenInNewIcon";
import { Stack } from "@mui/material";
import { businessMatchingBusinessEntityPath } from "../../../../../routes";

const TalkMessagesModal = ({
  talkRoom,
  currentBusinessEntity,
  isOpen,
  onClose,
}: {
  talkRoom: TalkRooms[number];
  currentBusinessEntity: SharedOwnedBusinessEntity;
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent h="100vh">
        <ModalHeader pb={0} px={3.5} py={4}>
          <HStack
            gap={3}
            borderBottomColor={"border.cardOutline"}
            borderBottomWidth={"1px"}
            pb={4}
          >
            <Avatar src={talkRoom.partner.image_url} boxSize={10} />
            <Stack gap={0}>
              <Text fontSize="sm" fontWeight="bold">
                {talkRoom.partner.name}
              </Text>
              {talkRoom.partner.status === "active" && (
                <HStack
                  gap={0.5}
                  fontSize="xs"
                  color="textLink"
                  pl={"1px"}
                  _hover={{
                    textDecoration: "underline",
                  }}
                >
                  <Link
                    textDecoration={"none"}
                    href={businessMatchingBusinessEntityPath(
                      talkRoom.partner.code,
                    )}
                    pt={"1px"}
                    target="_blank"
                  >
                    事業者情報を見る
                  </Link>
                  <OpenInNewIcon boxSize={4} />
                </HStack>
              )}
            </Stack>
          </HStack>
        </ModalHeader>
        <ModalCloseButton top={3} />
        <ModalBody
          display="flex"
          flexDirection="column"
          overflow="hidden"
          px={0}
          pt={0}
        >
          <TalkMessages
            key={talkRoom.code}
            talkRoom={talkRoom}
            currentBusinessEntity={currentBusinessEntity}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TalkMessagesModal;
